export const asArrow = {
  data: `<svg width="14" height="12" viewBox="0 0 14 12" xmlns="http://www.w3.org/2000/svg">
  <path d="M12.59 12L14 10.59L9.42 6L14 1.41L12.59 0L6.59 6L12.59 12Z"/>
  <path d="M6 12L7.41 10.59L2.83 6L7.41 1.41L6 0L0 6L6 12Z"/>
  </svg>
  `,
  name: 'arrow',
};
